import { QueryClient } from '@tanstack/react-query';

import { isRetryableApiError } from '@/shared/query-error-state/public';

const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;
const TEN_MINUTES_IN_MS = 10 * 60 * 1000;
const MAX_QUERY_RETRIES = 2;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: FIVE_MINUTES_IN_MS,
      gcTime: TEN_MINUTES_IN_MS,
      retry: import.meta.env.MODE === 'test' ? false : (failureCount, error) => isRetryableApiError(error) && failureCount < MAX_QUERY_RETRIES,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});
